var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderDot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 11,
    viewBox: "0 0 53 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(-639.982 -4230.941)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(639.982 4230.941)",
    fill: "#abbace"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(660.982 4230.941)",
    fill: "#00aeef"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(681.982 4230.941)",
    fill: "#00aeef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderDot);
export default __webpack_public_path__ + "static/media/slider-dot.41d178cc8db8ada9283ba4d5e1206daa.svg";
export { ForwardRef as ReactComponent };